var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.35C8.60016 12.35 7.73717 12.0076 7.10089 11.3981C6.4646 10.7886 6.10714 9.96195 6.10714 9.1C6.10714 8.23805 6.4646 7.4114 7.10089 6.8019C7.73717 6.19241 8.60016 5.85 9.5 5.85C10.3998 5.85 11.2628 6.19241 11.8991 6.8019C12.5354 7.4114 12.8929 8.23805 12.8929 9.1C12.8929 9.5268 12.8051 9.94941 12.6346 10.3437C12.4641 10.738 12.2142 11.0963 11.8991 11.3981C11.5841 11.6999 11.21 11.9393 10.7984 12.1026C10.3868 12.2659 9.94556 12.35 9.5 12.35ZM9.5 0C6.98044 0 4.56408 0.958747 2.78249 2.66533C1.00089 4.37191 0 6.68653 0 9.1C0 13.8598 4.62062 20.2004 7.41692 23.6018C8.51308 24.9351 10.4869 24.9351 11.5831 23.6018C14.3794 20.2004 19 13.8598 19 9.1C19 6.68653 17.9991 4.37191 16.2175 2.66533C14.4359 0.958747 12.0196 0 9.5 0Z",
    fill: "#20C533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.15d18c74aa742de1d44e529f41128f28.svg";
export { ForwardRef as ReactComponent };